module.exports = __webpack_public_path__ + "assets/img/block-right-hover-617a3c24.png";